// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__hglcB","bigColWidth":"Table_bigColWidth__6m0WB","biggerColWidth":"Table_biggerColWidth__2xeOv","row":"Table_row__pdZYv","col":"Table_col__N72a_"};